'use strict';

var addPlural = require('./addPlural'),
    addSingular = require('./addSingular');

function addIrregular(singular, plural) {
  var sReg = RegExp(singular + '$', 'i');
  var pReg = RegExp(plural + '$', 'i');
  addPlural(sReg, plural);
  addPlural(pReg, plural);
  addSingular(pReg, singular);
  addSingular(sReg, singular);
}

module.exports = addIrregular;